(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@hs/uppy-msg", [], factory);
	else if(typeof exports === 'object')
		exports["@hs/uppy-msg"] = factory();
	else
		root["@hs/uppy-msg"] = factory();
})(window, function() {
return 